import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild, AfterContentInit } from '@angular/core';
import { TipoDesconexion, Posicion } from '../solucion/solucion.entity';
import { NavegacionService } from '../sidenav.service';
import { Respuesta, Pregunta, RespuestaTipoOpciones } from '../cuestionario/cuestionario.entity';
import { Etapa, Desconexion } from '../diagnostico/Diagnostico.entity';
import { CuestionarioHttpServicesService } from '../cuestionario-http-services.service';
import { Dimension } from '../solucion/Dimension.entity';
import { Capa } from '../solucion/Capa.entity';
import {trigger, state, style, animate, transition, group} from '@angular/animations';
import { LoaderService } from '../loader.service';
import { User } from '../shared/user.model';
import { UserService } from '../shared/user.service';
import * as jsPDF from 'jspdf';
import * as html2canvas from 'html2canvas';
import {MatDialog, MatDialogRef} from '@angular/material';

@Component({
  selector: 'app-solucion-document',
  templateUrl: './solucion-document.component.html',
  styleUrls: ['./solucion-document.component.css']
})

export class SolucionDocumentComponent implements OnInit, AfterContentInit {

  @ViewChild('pdfwrapper') pdfwrapper: ElementRef;
  public error = false;
  public errorMessage = '';

  public _posicionesCentro: Posicion[] = [{top: 250, left: 250},
    {top: 280, left: 230}, {top: 250, left: 340}, {top: 280, left: 360},
    {top: 340, left: 360}, {top: 360, left: 320}, {top: 360, left: 250},
    {top: 340, left: 230}, {top: 260, left: 300}, {top: 370, left: 300}];
  public _posicionesAroExterior: Posicion[] = [{top: -60, left: 300},
      {top: 0, left: 500}, {top: 180, left: 630}, {top: 300, left: 655},
      {top: 420, left: 630}, {top: 580, left: 520}, {top: 655, left: 300},
      {top: 580, left: 80},  {top: 420, left: -40}, {top: 300, left: -60},
      {top: 180, left: -40},  {top: 0, left: 0} ];
       // Indice del 6 al 11
  public _posicionSuperior: Posicion[] = [{top: 130, left: 250}, {top: 210, left: 250 }, // Interior
        {top: 130, left: 340}, {top: 130, left: 380},
        {top: 220, left: 360}, {top: 220, left: 320},
        {top: 60, left: 380}, {top: 80, left: 230}, {top: 60, left: 250}, // Exterior
        {top: 210, left: 340}]; // Interior
        // Indice del 12 al 17
  public _posicionDerecha: Posicion[] = [{top: 250, left: 450},
          {top: 250, left: 550},
          {top: 250, left: 420}, {top: 380, left: 450}, {top: 340, left: 420}, // Interior
          {top: 340, left: 550}, {top: 220, left: 500}, {top: 380, left: 550}, // Exterior
          {top: 210, left: 550}, {top: 210, left: 550}];
          // Indice del 24 al 29
  public _posicionInferior: Posicion[] = [{top: 540, left: 230}, {top: 580, left: 250},
          {top: 480, left: 420}, {top: 420, left: 360}, {top: 420, left: 380},
          {top: 480, left: 340}, {top: 420, left: 200}, {top: 520, left: 230}, // Interior
          {top: 580, left: 380} , {top: 580, left: 340}]; // Exterior
          // Indice del 18 al 23
  public _posicionIzquierda: Posicion[] = [{top: 250, left: 80}, // Exterior
            {top: 250, left: 120}, {top: 250, left: 180}, {top: 340, left: 200}, // Interior
            {top: 340, left: 180}, {top: 340, left: 200}, {top: 380, left: 200},
            {top: 380, left: 80},
            {top: 210, left: 40}, {top: 210, left: 80}]; // Exterior
  public _etapas: Etapa[];
  public _respuestas: Respuesta[];
  public _preguntas: Pregunta[];
  public _respuestatipoopciones: RespuestaTipoOpciones[];
  public _capa: Capa[];
  public currentEtapa: Etapa = null;
  public item = 99;
  public itemDesco = 99;
  public _desconexiones: TipoDesconexion[] = [];
  public _dimensiones: Dimension[];
  isIzquierdoDisconnected = false;
  isDerechoDisconnected = false;
  isSuperiorDisconnected = false;
  isInferiorDisconnected = false;
  isCenterDisconnected = false;
  isfirstDisconnected = false;
  issecondDisconnected = false;
  isthirdDisconnected = false;
  isfourthDisconnected = false;
  isfifthDisconnected = false;
  issixthDisconnected = false;
  isseventhDisconnected = false;
  iseighthDisconnected = false;
  isleadershipDisconnected = false;
  currentClient: User = null;
  isShowlikedisabled = false;
  constructor( public _sidenav: NavegacionService,
    private _cuestionarioServices: CuestionarioHttpServicesService,
    private loaderService: LoaderService,
    public userService: UserService ,
    public dialogRef: MatDialogRef<SolucionDocumentComponent> ) { }
  ngOnInit() {
     // alert('');
     // console.log('En pdf init!');
     this.loaderService.display(true);
     this.currentClient = this._sidenav.currentClient;
     // this.userService.getUserClaims().subscribe((data: any) => {
     //  this.currentClient = data;
     // console.log('En el init de solucion:' , this.currentClient);
      // this._sidenav.recursos(false);
      this._cuestionarioServices.getEtapa().subscribe( objEtapa => {
      this._cuestionarioServices.getRespuestas(this._sidenav.currentDiag.diagnosticoID).subscribe( objRespuestas => {
      this._cuestionarioServices.getPreguntas().subscribe( objPreguntas => {
      this._cuestionarioServices.getRespuestaTipoOpciones().subscribe( objRtop => {
      this._cuestionarioServices.getDimension().subscribe( objDim => {
      this._cuestionarioServices.getCapas().subscribe( objCapa => {
                this._capa   = objCapa;
                this._respuestas = objRespuestas;
                this._etapas = objEtapa;
                this._preguntas = objPreguntas;
                this._respuestatipoopciones = objRtop;
                this._dimensiones = objDim;
                this.currentEtapa = this._etapas.filter(x => x.descripcion === 'DESCONEXIONES')[0];
                this.CalcularDesconexiones();
                this.isShowlikedisabled = true;
                this.loaderService.display(false);
                // const element: HTMLElement = document.getElementById('switcher') as HTMLElement;
                // element.click();
          }, err => {this.errorMessage = err.message; this.error = true; } );
        }, err => {this.errorMessage = err.message; this.error = true; } );
       }, err => {this.errorMessage = err.message; this.error = true; } );
      }, err => {this.errorMessage = err.message; this.error = true; } );
     }, err => {this.errorMessage = err.message; this.error = true; } );
    // }, err => {this.errorMessage = err.message; this.error = true; } );
  });
  }
  CalcularDesconexiones() {
    // Recorrer el cuestionario y buscar por capa segun la cantidad mayor de repeticiones
    // Mostrar Desonexiones.
    // const etapaDimension = this._etapas.find(etapa => etapa.descripcion === 'Dimension');
    this._desconexiones = [];
    this.isIzquierdoDisconnected = false;
    this.isDerechoDisconnected = false;
    this.isSuperiorDisconnected = false;
    this.isInferiorDisconnected = false;
    this.isfirstDisconnected = false;
    this.issecondDisconnected = false;
    this.isthirdDisconnected = false;
    this.isfourthDisconnected = false;
    this.isfifthDisconnected = false;
    this.issixthDisconnected = false;
    this.isseventhDisconnected = false;
    this.iseighthDisconnected = false;
    this.isleadershipDisconnected = false;
    console.log(this.currentClient.clienteID);
    this._cuestionarioServices.getResumenDesconexion(this._sidenav.currentDiag.diagnosticoID).subscribe( objTipoDesconexion => {
    this._cuestionarioServices.getDesconexion().subscribe( objDesconexion => {
      // console.log(objTipoDesconexion);
      objTipoDesconexion.forEach(element => {
        element.desconexion = objDesconexion.find( x => x.desconexionID === element.desconexionID);
        // console.log(element.desconexion);
        this._desconexiones.push(element);
        // Ordeno por como esta armado el canvas, primero superior en sentido del reloj
        //    Todo lo de afuera primero y despues lo de adentro. Comenzamos por el centro.
        if (element.desconexionID === 1) {
          this.isCenterDisconnected = true;
        }
        if (element.desconexionID === 3) { // Desconexion: Planes
          this.isfirstDisconnected = true; // Capa: Planes  Ubicacion: Superior Afuera
          this.isSuperiorDisconnected = true;
        }
        if (element.desconexionID === 9) { // Desconexion:Integracion Transversal
          this.issecondDisconnected = true; // Capa:  Integracion Transversal Ubicacion: Derecha Afuera
          this.isDerechoDisconnected = true;
        }
        if (element.desconexionID === 7) { // Desconexion: Comportamiento
          this.isthirdDisconnected = true; // Capa: Comportamiento Ubicacion: Abajo Afuera
          this.isInferiorDisconnected = true;
        }
        if (element.desconexionID === 4) { // Desconexion: Diseño Organizativo
          this.isfourthDisconnected = true; // Capa: Diseño Organizativo  Ubicacion: Izquierda afuera
          this.isIzquierdoDisconnected = true;
        }
        if (element.desconexionID === 2) { // Desconexion: Estrategia Valor
          this.isfifthDisconnected = true; //  Capa Estrategia Valor Ubicacion: Superior Adentro
          this.isSuperiorDisconnected = true;
        }
        if (element.desconexionID === 8) { // Desconexion: Proceso y tecnologia
          this.issixthDisconnected = true; // Capa: Proceso y tecnologia Ubicacion:  Derecha Adentro
          this.isDerechoDisconnected = true;
        }
        if (element.desconexionID === 6) { // Desconexion: Procesos- Creencia y supuestos
          this.isseventhDisconnected = true; // Capa: Creencia y supuestos  Ubicacion: Abajo Adentro
          this.isInferiorDisconnected = true;
        }
        if (element.desconexionID === 5) { // Desconexion: Capacidad
          this.iseighthDisconnected = true; // Capa: Capacidad  Ubicacion: Izquierda Adentro
          this.isIzquierdoDisconnected = true;
        }
        if (element.desconexionID === 10) { // Liderazgo
          this.isleadershipDisconnected = true;
        }
      }); });
    });
  }

  ngAfterContentInit() {
    console.log('After init');
    // const doc = jsPDF();
    // doc.addHTML(document.getElementById('pdfwrapper')
    //  , 10, 10, {pagesplit: true,
    //    margin: {top: 10, right: 10, bottom: 10, left: 10, useFor: 'page'}},
    //     function () {doc.save('test.pdf'); } );

    // this.sleep(5000);
    // this.generate();
    // this.print2();
    // this.makePDF();
    //  this.makepdf2();
    // this.makepdf3();
    // this.makepdf3();
      // html2canvas( document.body ).then(function(canvas) {
      // const img = canvas.toDataURL('image/png');
      // document.getElementById("myDIV").appendChild(canvas);
      // const doc = new jsPDF();
      // doc.addImage(img, 'JPEG', 5 , 20);
      // doc.save('Test.pdf');
      // });
      // const input = document.getElementById('pdfwrapper');
      // html2canvas(input)
      //     .then((canvas) => {
      //         const pdf = new jsPDF();
      //         pdf.addHTML(input, 0, 0, {
      //             pagesplit: true,
      //             background: '#ffffff',
      //         }, () => {
      //             pdf.save('download.pdf');
      //         });
      //     });
  }

  print2() {
    const innerContents = document.getElementById('pdfwrapper').innerHTML;
    const popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,' +
    'menubar=no,toolbar=no,location=no,status=no,titlebar=no');
    popupWinindow.document.open();
    popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="assets/scss/tool-styles.scss" />' +
    '</head><body onload="window.print()">' + innerContents + '</html>');
    popupWinindow.document.close();
  }
  printComponent() {
    let  printContents = '<html lang="en"><head>  <meta charset="UTF-8"> '
              + ' <meta name="viewport" content="width=device-width, initial-scale=1.0">'
              + '  <meta http-equiv="X-UA-Compatible" content="ie=edge">   '
              + ' <title>AMG - Transformación Organizacional</title>   '
              + ' <link href="https://fonts.googleapis.com/css?family=Montserrat:500,700|Work+Sans:400,700" rel="stylesheet"> '
              + '   <link rel="stylesheet" href="../../assets/scss/tool-styles.scss"></head><body class="section-diagnostics">';
    printContents = printContents + document.getElementById('pdfwrapper').innerHTML;
    printContents = printContents + '</body></html>';
    console.log(printContents);
    const originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;

    window.print();

    document.body.innerHTML = originalContents;
}
  makePDF() {

    const quotes = document.getElementById('pdfwrapper');

    html2canvas(quotes).then(function(canvas) {

        // ! MAKE YOUR PDF
        const pdf = new jsPDF('p', 'pt', 'letter');

        for (let i = 0; i <= quotes.clientHeight / 980; i++) {
            // ! This is all just html2canvas stuff
            const srcImg  = canvas;
            const sX      = 0;
            const sY      = 980 * i; // start 980 pixels down for every new page
            const sWidth  = 900;
            const sHeight = 980;
            const dX      = 0;
            const dY      = 0;
            const dWidth  = 900;
            const dHeight = 980;

            const onePageCanvas = document.createElement('canvas');
            onePageCanvas.setAttribute('width', '900');
            onePageCanvas.setAttribute('height', '980');
            const ctx = onePageCanvas.getContext('2d');
            // details on this usage of this function:
            // https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API/Tutorial/Using_images#Slicing
            ctx.drawImage(srcImg, sX, sY, sWidth, sHeight, dX, dY, dWidth, dHeight);

            // document.body.appendChild(canvas);
            const canvasDataURL = onePageCanvas.toDataURL('image/png', 1.0);

            const width         = onePageCanvas.width;
            const height        = onePageCanvas.clientHeight;

            // ! If we're on anything other than the first page,
            // add another page
            if (i > 0) {
                pdf.addPage(612, 791); // 8.5" x 11" in pts (in*72)
            }
            // ! now we declare that we're working on that page
            pdf.setPage(i + 1);
            // ! now we add content to that page!
            pdf.addImage(canvasDataURL, 'PNG', 20, 40, (width * .62), (height * .62));

        }
        // ! after the for loop is finished running, we save the pdf.
        pdf.save('Test.pdf');
  });
}
makepdf2() {
  html2canvas( document.getElementById('pdfwrapper') ).then(function(canvas) {
  const imgData = canvas.toDataURL('image/png');

  /*
  Here are the numbers (paper width and height) that I found to work.
  It still creates a little overlap part between the pages, but good enough for me.
  if you can find an official number from jsPDF, use them.
  */
 const imgWidth = 210;
 const pageHeight = 295;
 const imgHeight = canvas.height * imgWidth / canvas.width;
 let heightLeft = imgHeight;

 const doc = new jsPDF('p', 'mm');
 let position = 0;

  doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
  heightLeft -= pageHeight;

  while (heightLeft >= 0) {
    position = heightLeft - imgHeight;
    doc.addPage();
    doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;
  }
  doc.save( 'file.pdf');
  });
}

makepdf3() {
  html2canvas( document.getElementById('pdfwrapper') ).then(function(canvas) {
    // const imgData = canvas.toDataURL('image/png');
    const contentWidth = canvas.width;
    const contentHeight = canvas.height;
    // The height of the canvas which one pdf page can show;
    const pageHeight = contentWidth / 592.28 * 841.89;
    // the height of canvas that haven't render to pdf
    let leftHeight = contentHeight;
    // addImage y-axial offset
    let position = 0;
    // a4 format [595.28,841.89]
    const imgWidth = 595.28;
    const imgHeight = 592.28 / contentWidth * contentHeight;

    const pageData = canvas.toDataURL('image/jpeg', 1.0);

    const pdf = new jsPDF('', 'pt', 'a4');

    if (leftHeight < pageHeight) {
    pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight );
    } else {
    while (leftHeight > 0) {
      pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
      leftHeight -= pageHeight;
      position -= 841.89;
      // avoid blank page
      if (leftHeight > 0) {
          pdf.addPage();
      }
    }
    }

    pdf.save('content.pdf');
    });
}
  sleep(delay) {
    const start = new Date().getTime();
    while (new Date().getTime() < start + delay) {}
  }


  Cancelar() {
    this._sidenav.Iniciar();
  }
  test(obj: MouseEvent) {
    alert(obj.srcElement.innerHTML);
    alert(this.item);
  }
  showlikedisabled(evt: MouseEvent) {
    this.isShowlikedisabled = !this.isShowlikedisabled;
    evt.stopPropagation();
  }
  GetRespuestas(): Respuesta[] {
    if (this._respuestas !== undefined) {
    return this._respuestas.filter( a => a.respuestaTipoID === 1);
  }
}
GetCapa(id: number): string {
    if (this._capa !== undefined && this._capa.length > 0) {
      return this._capa.filter( a => a.capaId === id)[0].descripcion;
    } else {
      return '';
    }
}
isR(rp: Respuesta) {
  // console.log(rp.respuestaTipoOpcionID );
  return (rp.respuestaTipoOpcionID === 3);
}
isY(rp: Respuesta) {
  return (rp.respuestaTipoOpcionID === 2);
}
isG(rp: Respuesta) {
  return (rp.respuestaTipoOpcionID === 1);
}

  setStyleRespuesta(rp: Respuesta, index: number) {
    // console.log(rp, index);
    const dimID = this._preguntas.filter(x => x.preguntasID === rp.preguntasID)[0].dimensionID;
    // console.log(dimID);
  /*  Aleatorio izq der, posicionado por dimension.
  let styles = {
      'top': ((dimID === 2 ? 100 : dimID === 5 ? 500 : 300) + (6 * this.randomInt(1, 10) * ((index % 2) === 0 ? 1 : -1))).toString() + 'px',
      'left': ((dimID === 3 ? 500 : dimID === 4 ? 100 : 300) + (6 * this.randomInt(1, 10) * ((index % 2) === 0 ? 1 : -1))).toString() + 'px'
    };*/
   // Ramdon de un array de posiciones
   let pos: Posicion;
   switch (dimID) {
    case 1:
      pos  = this._posicionesCentro[(index % 10)];
    break;
    case 2:
      pos  = this._posicionSuperior[(index % 10)];
    break;
    case 3:
      pos  = this._posicionDerecha[(index % 10)];
    break;
    case 4:
      pos  = this._posicionIzquierda[(index % 10)];
    break;
    case 5:
      pos  = this._posicionInferior[(index % 10)];
    break;
    case 6:
      pos  = this._posicionesAroExterior[(index % 10)];
    break;
    }
    const styles = {
      'top': pos.top + 'px',
      'left': pos.left + 'px'
    };
    // console.log(dimID, index, styles);
    return styles;
  }
  randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
 }
  Get(id: number): Pregunta {
    const preguntas: Pregunta[] = this._preguntas;
    const  index = preguntas.findIndex( (a) => a.preguntasID === id);
    if (index < 0) {
      return null;
    }
    return preguntas[index];
  }
  getDescripcion(id: number): string {
    return this.Get(id).descripcion;
  }
  getDimensionDescripcionbypg(pregunta_id: number): string {
    return this._dimensiones.filter(x => x.dimensionID === this.Get(pregunta_id).dimensionID)[0].descripcion;
  }
  getDimensionDescripcion(id: number): string {
    return this._dimensiones.filter(x => x.dimensionID === id)[0].descripcion;
  }
  getDimensionCapa(id: number): string {
    return this._capa.filter(x => x.capaId === id)[0].descripcion;
  }
  getLeyendaResumen(): string {
    let resumen = '';
    let dim = '';
    let carUnion = '';
    const diagDescripcion = this._sidenav.currentDiag.descripcion;
    if (this.currentClient !== null && this.currentClient !== undefined) {
   //   if ( this._desconexiones.length === 1 ) {
   //     resumen = diagDescripcion + ' tiene una desconexión en ' + this._dimensiones[0].descripcion;
   //  } else {
    if ( this._desconexiones.length > 1 ) {
      resumen = diagDescripcion + ' tiene desconexiones en ';
    } else {
      if ( this._desconexiones[0].ValorDesconexion !== '1') {
        resumen = diagDescripcion + ' tiene una desconexión en ';
      } else {
        resumen = diagDescripcion + ' esta en equilibrio. ';
      }
    }
    this._desconexiones.forEach((element, index) => {
      const dimDesc = this._dimensiones.filter(x => x.dimensionID === element.dimensionID)[0].descripcion;
      if ( dim !== dimDesc) {
        resumen = resumen + carUnion + '"' + dimDesc + '"' ;
        if ( index === (this._desconexiones.length - 3)) { carUnion = ' y '; } else { carUnion = ', '; }
      }
      dim = dimDesc;
    });
    // }
    resumen = resumen + '.';
    }
    // console.log(resumen);
    return resumen ;
  }
  GetRespuestaAsociada(preguntaID: number, deOption?: boolean): string {
    // console.log('Get Respuesta' , preguntaID);
    let respuestaValue = '';
    const resp = this.GetRespuesta(preguntaID);
    if (resp != null) {
      respuestaValue = this.GetRespuesta(preguntaID).valor;
    // console.log(respuestaValue);
    if (resp.respuestaTipoID !== undefined && resp.respuestaTipoID === 3) {
      if (deOption !== undefined && deOption	) {
        // Opcion De:.....
        respuestaValue = respuestaValue.substring(3, respuestaValue.indexOf('Hacia:') - 1 );
      } else {
        // Opcion Hacia :.....
        respuestaValue = respuestaValue.substring(respuestaValue.indexOf('Hacia:') + 6 );
      }
    }
    }
    return respuestaValue ;
  }
  GetRespuestaAsociadaId(preguntaID: number, deOption?: boolean): number {
    // console.log('Get Respuesta' , preguntaID);
    let respuestaValue = 0;
    const resp = this.GetRespuesta(preguntaID);
    if (resp != null) {
      respuestaValue = this.GetRespuesta(preguntaID).respuestaTipoOpcionID;
    // console.log(respuestaValue);
    }
    return respuestaValue ;
  }
  GetRespuesta(id: number): Respuesta {
    let result: Respuesta = null;
    if (this._respuestas != null) {
        // alert(id);
        const  index = this._respuestas.findIndex( (a) => a.preguntasID === id);
        // alert(index);
        if (index < 0) {
          result = null;
        }
        result = this._respuestas[index];
      }
      return result;
  }
  setRespuestaId(preguntaID: number,  id: number): void {
    // console.log('set', preguntaID, value );
    this.loaderService.display(true);
    const pr = this.Get(preguntaID);
    // console.log('respuesta tipo ', pr.respuestaTipoID );
    const ropt = this._respuestatipoopciones.filter(x => x.respuestaTipoOpcionID === id)[0];
    // console.log('respuesta opcion', ropt);
    let resp: Respuesta;
    if (this._respuestas != null) {
      const index = this._respuestas.findIndex(item => item.preguntasID === preguntaID);
      if (index > -1) {
        resp =  this._respuestas[index];
        resp.valor = ropt.respuestaOpcion;
        resp.respuestaTipoOpcionID = ropt.respuestaTipoOpcionID;
        this._cuestionarioServices.UpdateRespuesta(resp).subscribe(
          obj => {
            this._cuestionarioServices.getRespuestas(this._sidenav.currentDiag.diagnosticoID).subscribe(
              objRespuestas => {
                    this._respuestas = objRespuestas;
                    this.CalcularDesconexiones();
            });
          });
      } else {
        resp = new Respuesta(null,
          this.currentClient,
          this.currentClient.clienteID,
          pr.respuestaTipoID,
          ropt.respuestaTipoOpcionID,
          ropt,
          pr,
          pr.preguntasID,
          this._sidenav.currentEtapa,
          this._sidenav.currentEtapa.etapaId,
          this._sidenav.currentDiag.diagnosticoID,
          ropt.respuestaOpcion);
          this._cuestionarioServices.AddRespuesta(resp).subscribe(
              obj => {
                this._cuestionarioServices.getRespuestas(this._sidenav.currentDiag.diagnosticoID).subscribe(
                  objRespuestas => {
                        this._respuestas = objRespuestas;
                        this.CalcularDesconexiones();
                });
              });
          // this._respuestas.push(resp);
        }
    } else {
      resp = new Respuesta(null,
        this.currentClient,
        this.currentClient.clienteID,
        pr.respuestaTipoID,
        ropt.respuestaTipoOpcionID,
        ropt,
        pr,
        pr.preguntasID,
        this._sidenav.currentEtapa,
        this._sidenav.currentEtapa.etapaId,
        this._sidenav.currentDiag.diagnosticoID,
        ropt.respuestaOpcion);
        this._cuestionarioServices.AddRespuesta(resp).subscribe(
          obj => {
            this._cuestionarioServices.getRespuestas(this._sidenav.currentDiag.diagnosticoID).subscribe(
              objRespuestas => {
                    this._respuestas = objRespuestas;
                    this.CalcularDesconexiones();
            });
          });
        // this._respuestas.push(resp);
      }
      this.loaderService.display(false);
    }
  windowprint() {
    window.print();
  }
  closemodal() {
    this.dialogRef.close();
  }
}




// WEBPACK FOOTER //
// ./src/app/solucion-document/solucion-document.component.ts